
import { cn } from '@/lib/utils';

export type FormStep = 1 | 2 | 3;

const STEPS: FormStep[] = [1, 2, 3];

const STEP_LABELS: Record<FormStep, string> = {
  1: 'Choose',
  2: 'Share',
  3: 'Connect',
};

interface PrayerFormProgressProps {
  currentStep: FormStep;
  className?: string;
}

export function PrayerFormProgress({ currentStep, className }: PrayerFormProgressProps) {
  if (currentStep === 1) return null;

  return (
    <div className={cn('mb-8 space-y-3', className)}>
      <p className="text-center text-sm text-slate-500 dark:text-slate-400">
        Step {currentStep} of 3 · {STEP_LABELS[currentStep]}
      </p>
      <div
        className="flex justify-center gap-2"
        aria-label="Walkthrough progress"
        role="list"
      >
        {STEPS.map((step) => (
          <div
            key={step}
            role="listitem"
            aria-current={step === currentStep ? 'step' : undefined}
            aria-label={STEP_LABELS[step]}
            className={cn(
              'h-1.5 w-8 rounded-full transition-all duration-300',
              step <= currentStep
                ? 'bg-primary-600 dark:bg-primary-500'
                : 'bg-slate-200 dark:bg-slate-700',
              step === currentStep && 'w-10'
            )}
          />
        ))}
      </div>
    </div>
  );
}
